export const formatDateForForm = (date?: string) => {
  const dateObj = date ? new Date(date) : new Date();

  return dateObj.toLocaleDateString('en-CA');
};
